/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _6 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>6 - Стрелочные функции</h2>
    <p className={styles.description}>
      Стрелочные функции имеют сокращенный, более лаконичный синтаксис, и некоторые особенности. Подобно функциональным
      выражениям они присваиваются переменным или могут быть анонимными. Их использование очень удобно и значительно
      сокращает объемы кода, особенно когда функция маленькая.{' '}
    </p>
    <p className={styles.description}>
      Все стрелки создаются с помощью функционального выражения, если функция не анонимна, то она должна быть присвоена
      переменной. Поэтому следует помнить, что перед использованием стрелочной функции её всегда необходимо создать
      заранее.{' '}
    </p>
    <CopyBlock
      text={`// Обычное функциональное выражение
const add = function(a, b, c) {
  return a + b + c;
};

// Тоже самое записно как стрелочная функция
const add = (a, b, c) => a + b + c;`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Слово <code className={styles.code}>function</code> не используется, вместо этого сразу идет объявление
      параметров, за которыми всегда следует символ <code className={styles.code}>=></code>.{' '}
    </p>
    <CopyBlock
      text={`// Если параметров несколько, то они перечисляются через запятую в круглых скобках.
const fn = (a, b, c) => {
  return a + b + c;
};

// Если параметр один, то он может быть без круглых скобок.
const fn = x => {
  return x * 2;
};

// Если параметров нет, то обязательно должны быть пустые круглые скобки.
const fn = () => {
  console.log('Hello! :]');
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      После <code className={styles.code}>=></code> идет тело функции. Здесь может быть два варианта: с фигурными
      скобками и без них.
    </p>
    <CopyBlock
      text={`/*
 * Если фигурные скобки после => есть, значит необходимо явно указать то,
 * что должна вернуть функция - поставить return и выражение.
 * Это называется явный возврат (explicit return)
 */
const fn = (a, b, c) => {
  return a + b + c;
};

/*
 * Если фигурных скобок нет, то возвращается результат выражения стоящего после =>
 * Это называется неявный возврат (implicit return)
 * В примере ниже вернется результат выражения сложения a, b и c
 */
const fn = (a, b, c) => a + b + c;`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>6.1 - Стрелочные функции и arguments</h3>
      <p className={styles.description}>
        У стрелочных функций нет локальной переменной <code className={styles.code}>arguments</code>, содержащей все
        аргументы. Если необходимо собрать все аргументы в массив, используется операция{' '}
        <code className={styles.code}>rest</code>.{' '}
      </p>
      <CopyBlock
        text={`const add = (...args) => {
  console.log(args);
};

add(1, 2, 3); // [1, 2, 3]`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
  </section>
))
